var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({staticClass:"Icon",class:_vm.iconClasses,attrs:{"alt":_vm.name,"src":_vm.src},on:{"click":function($event){return _vm.$emit('click')}}},'img',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }